import * as React from "react"

export const NewChatIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.651 21.682a14.6 14.6 0 0 1-.975-2.775A12.4 12.4 0 0 1 3.333 16q0-2.628.998-4.94a12.8 12.8 0 0 1 2.707-4.022 12.8 12.8 0 0 1 4.02-2.707q2.313-.998 4.94-.998t4.94.998a12.8 12.8 0 0 1 4.023 2.707 12.8 12.8 0 0 1 2.708 4.02q.998 2.313.998 4.94t-.998 4.94a12.8 12.8 0 0 1-2.707 4.023 12.8 12.8 0 0 1-4.022 2.708q-2.312.998-4.94.998-1.486 0-2.907-.343a14.6 14.6 0 0 1-2.775-.975l-5.9 1.727q-.684.21-1.194-.3t-.3-1.195zm.616 5.051 4.266-1.266a3.1 3.1 0 0 1 .95-.113q.458.021.917.246a10 10 0 0 0 2.233.8 10.6 10.6 0 0 0 2.367.267q4.467 0 7.567-3.1t3.1-7.567-3.1-7.567T16 5.333t-7.567 3.1q-3.1 3.101-3.1 7.567 0 1.2.267 2.367.266 1.166.8 2.233.234.433.256.917.024.483-.123.95zM15 17v3q0 .424.288.712A.97.97 0 0 0 16 21a.97.97 0 0 0 .713-.288A.97.97 0 0 0 17 20v-3h3q.424 0 .712-.288A.97.97 0 0 0 21 16a.97.97 0 0 0-.288-.713A.97.97 0 0 0 20 15h-3v-3a.97.97 0 0 0-.288-.712A.97.97 0 0 0 16 11a.97.97 0 0 0-.713.288A.97.97 0 0 0 15 12v3h-3a.97.97 0 0 0-.712.288A.97.97 0 0 0 11 16q0 .425.288.713A.97.97 0 0 0 12 17z"
    ></path>
  </svg>
)
